import React, { Component, Fragment } from 'react';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import Button from '../../components/form/Button';
import gql from 'graphql-tag';
import { Query } from '../../reactApolloCompat';
import PrintContent from '../../components/PrintContent';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import cloneDeep from 'lodash.clonedeep';
import withStyles from '@mui/styles/withStyles';
import Hidden from '../../components/Hidden';
import moment from 'moment';
import Inline, { inlineAlignment } from '../../components/layout/Inline';
import PrintIcon from '../../components/icon/PrintIcon';
import DatePickerField from '../../components/form/DatePickerField';
import ErrorFallback from '../../components/ErrorFallback';
import { withErrorBoundary } from '@sentry/react';
import { GQL_REFETCH_60S, subscribe } from '../../utils/subscriptions';
import LinearProgressIndicator from '../../components/loading/LinearProgressIndicator';
import DispatchDate from '../../fragments/DispatchDate';
import Deceased from '../../fragments/Deceased';
import Member from '../../fragments/Member';
import { flattenConnection } from '../../utils/objects';
import Client from '../../fragments/Client';
import CremationManagerAddressBook from '../../fragments/AddressBook';
import Quote from '../../fragments/Quote';
import AshLocation from '../../fragments/AshLocation';
import Appointment from '../../fragments/Appointment';
import Address from '../../fragments/Address';
import { joinDefined } from '../../utils/strings';
import PickupRunsheet from './PickupRunsheet';
import DeliveryRunsheet from './DeliveryRunsheet';
import Pickup from '../../fragments/Pickup';

class Delivery extends Component {
    constructor(props) {
        super(props);

        const saved = JSON.parse(sessionStorage.getItem('delivery')) || {};
        const date = saved.date || moment().format('YYYYMMDD');
        const until = saved.until || moment().format('YYYYMMDD');

        this.state = {
            dateFrom: moment(date).format('YYYY-MM-DD'),
            dateTo: moment(until).format('YYYY-MM-DD')
        };

        this.runsheetQueryRef = React.createRef();
        subscribe(this.runsheetQueryRef, GQL_REFETCH_60S);
        this.runsheetQueryRef2 = React.createRef();
        subscribe(this.runsheetQueryRef2, GQL_REFETCH_60S);
        this.runsheetQueryRef3 = React.createRef();
        subscribe(this.runsheetQueryRef3, GQL_REFETCH_60S);
        this.storePolling = null;
    }

    dateChange = e => {
        const { dateFrom, dateTo } = this.state;
        const diff = moment(dateTo).diff(dateFrom, 'days');
        // enforce a maximum of 7 days in the runsheet.
        const newDates = { dateFrom, dateTo };

        if (e.target.name === 'dateFrom') {
            if (moment(e.target.value).isAfter(dateTo)) {
                newDates.dateFrom = moment(e.target.value).format('YYYY-MM-DD');
                newDates.dateTo = moment(e.target.value)
                    .add(diff, 'days')
                    .format('YYYY-MM-DD');
            } else if (moment(e.target.value).isBefore(moment(dateTo).subtract(7, 'days'))) {
                newDates.dateFrom = moment(e.target.value).format('YYYY-MM-DD');
                newDates.dateTo = moment(e.target.value)
                    .add(diff, 'days')
                    .format('YYYY-MM-DD');
            } else if (!!e.target.value) {
                newDates.dateFrom = e.target.value;
            }
        } else {
            if (moment(e.target.value).isBefore(dateFrom)) {
                newDates.dateTo = moment(e.target.value).format('YYYY-MM-DD');
                newDates.dateFrom = moment(e.target.value)
                    .subtract(diff, 'days')
                    .format('YYYY-MM-DD');
            } else if (moment(e.target.value).isAfter(moment(dateFrom).add(7, 'days'))) {
                newDates.dateTo = moment(e.target.value).format('YYYY-MM-DD');
                newDates.dateFrom = moment(e.target.value)
                    .subtract(diff, 'days')
                    .format('YYYY-MM-DD');
            } else if (!!e.target.value) {
                newDates.dateTo = e.target.value;
            }
        }
        sessionStorage.setItem(
            'delivery',
            JSON.stringify({
                date: moment(newDates.dateFrom).format('YYYYMMDD'),
                until: moment(newDates.dateTo).format('YYYYMMDD')
            })
        );

        this.setState(newDates, () => this.restartPolling());
    };

    restartPolling = () => {
        if (this.storePolling) {
            this.storePolling.stop.forEach(obj => obj());
            this.storePolling.start.forEach(obj => obj(GQL_REFETCH_60S));
        }
    };

    FilterByDate(data, dateObjs, query) {
        const { dateFrom, dateTo } = this.state;
        const original = cloneDeep(data);
        flattenConnection(original, query);

        let datesTimesAdded = [];

        const items = original?.[query];
        if (!items) return datesTimesAdded;

        items.forEach(function(item) {
                dateObjs.every(dateObj => {
                    if (!item[dateObj]) return true;
                    const dateTimeStr = (dateObj === 'Date' && item.Time)
                        ? joinDefined([item.Date, item.Time], ' ')
                        : item[dateObj];
                    let date = moment(dateTimeStr);
                    if (date.isBetween(dateFrom, dateTo, 'day', '[]')) {
                        item['Date'] = date.format('YYYY-MM-DD');
                        item['Time'] = date.format('HH:mm:ss');
                        item['Type'] = query;
                        datesTimesAdded.push(item);
                        return false;
                    }
                    return true;
                });
        });

        return datesTimesAdded;
    }

    getUniqueDates(days, task, key) {
        task.forEach(function(item) {
            if (!(item[key] in days)) {
                days[item[key]] = [];
            }
            let tempDays = days[item[key]];
            if (!tempDays.task) {
                tempDays.task = [];
                tempDays.task.push(item);
            } else {
                tempDays.task.push(item);
            }
        });

        return days;
    }

    addUniqueDaysToDaysPickup(data, daylist) {
        const arrEnquiries = data?.readCMEnquiries?.edges ?? [];
        const arrOrders = data?.readCremationOrders?.edges ?? [];

        const pickups = [
            ...arrEnquiries.map(edge => {
                const pickup = edge.node.Pickup;
                return {
                    ...edge.node,
                    Date: pickup.Date,
                    Time: pickup.Time,
                    Type: 'readCMEnquiries'
                };
            }),
            ...arrOrders.map(edge => {
                const pickup = edge.node.Pickup;
                return {
                    ...edge.node,
                    Date: pickup.Date,
                    Time: pickup.Time,
                    Type: 'readCremationOrders'
                };
            })
        ];

        const pickupOrderIds = new Set(
            pickups
                .filter(p => p.Type === 'readCremationOrders')
                .map(p => p.ID)
        );

        const filteredPickups = pickups.filter(p => {
            if (p.Type === 'readCMEnquiries') {
                const cremOrderId = p.CremationOrder && p.CremationOrder.ID;
                if (cremOrderId && pickupOrderIds.has(cremOrderId)) {
                    return false;
                }
            }
            return true;
        });

        return this.getUniqueDates(
            daylist,
            filteredPickups.sort(
                (a, b) => moment(joinDefined([a.Date, a.Time], ' ')) - moment(joinDefined([b.Date, b.Time], ' '))
            ),
            'Date'
        );
    }

    addUniqueDaysToDaysDispatchDates(data, daylist) {
        let cremDeliveries = [].concat(this.FilterByDate(data, ['Date'], 'readCMCremationDispatchDates'));

        //cycle through appointments and create unique days
        return this.getUniqueDates(
            daylist,
            cremDeliveries.sort(
                (a, b) => moment(joinDefined([a.Date, a.Time], ' ')) - moment(joinDefined([b.Date, b.Time], ' '))
            ),
            'Date'
        );
    }

    renderHeader() {
        const { dateFrom, dateTo } = this.state;
        return (
            <Grid container mr={10}>
                <Grid item xs={12} sm={12} md={3}>
                    <Inline alignment={inlineAlignment.rightAlignSiblings} center>
                        <h1 className="title">Driver</h1>
                        <Hidden mdUp>
                            <PrintContent
                                pageStyle={
                                    '@media print { body { -webkit-print-color-adjust: exact; color-adjust: exact; } }'
                                }
                                trigger={() => (
                                    <Button variant="primary icon-button">
                                        <PrintIcon />
                                    </Button>
                                )}
                                content={() => this.formRef}
                            />
                        </Hidden>
                    </Inline>
                </Grid>
                <Grid item xs={6} md={3}>
                    <DatePickerField
                        label="From"
                        type="date"
                        value={dateFrom}
                        name="dateFrom"
                        onChange={this.dateChange}
                    />
                </Grid>
                <Grid item xs={6} md={3}>
                    <DatePickerField
                        label="Until"
                        type="date"
                        value={dateTo}
                        name="dateTo"
                        onChange={this.dateChange}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={3}>
                    <Hidden smDown>
                        <Inline className="button-alignment" alignment={inlineAlignment.right}>
                            <PrintContent
                                pageStyle={
                                    '@media print { body { -webkit-print-color-adjust: exact; color-adjust: exact; } }'
                                }
                                trigger={() => (
                                    <Button variant="primary">
                                        <PrintIcon />
                                        <Hidden smDown>Print</Hidden>
                                    </Button>
                                )}
                                content={() => this.formRef}
                            />
                        </Inline>
                    </Hidden>
                </Grid>
            </Grid>
        );
    }

    renderDays(data, networkStatus) {
        const { dateFrom, dateTo } = this.state;
        const getDays = () => {
            let arr = {};
            let dt = dateFrom;
            while (moment(dt) <= moment(dateTo)) {
                arr[moment(dt).format('YYYY-MM-DD')] = [];
                dt = moment(dt).add(1, 'd');
            }
            return arr;
        };
        let daylist1 = getDays();
        daylist1 = this.addUniqueDaysToDaysPickup(data, daylist1);

        let days = [];
        for (let key in daylist1) {
            days.push(key);
        }

        let daylist2 = getDays();
        daylist2 = this.addUniqueDaysToDaysDispatchDates(data, daylist2);

        return (
            <Fragment>
                {!!networkStatus && networkStatus !== 7 && (
                    <Fragment>
                        <div>Loading data, please wait a moment...</div>
                        <LinearProgressIndicator />
                    </Fragment>
                )}
                {days &&
                    days.length > 0 &&
                    days.map((day, idx) => {
                        const hasPickupsfromFD = !!daylist1[days[idx]] && !!daylist1[days[idx]].task;
                        const pickupItems = hasPickupsfromFD ? daylist1[days[idx]].task : [];
                        const hasDeliveries = !!daylist2[days[idx]] && !!daylist2[days[idx]].task;
                        const deliveryItems = hasDeliveries ? daylist2[days[idx]].task : [];
                        const combinedItems = [...pickupItems, ...deliveryItems].sort(
                            (a, b) =>
                                moment(joinDefined([a.Date, a.Time], ' ')) -
                                moment(joinDefined([b.Date, b.Time], ' '))
                        );

                        return (
                            <Paper elevation={0} key={idx} className={idx ? 'page-break' : null}>
                                <Grid container>
                                    <Grid item>
                                        <h2>Driver Run Sheet for {moment(day).format('dddd[,] LL')}</h2>
                                        <Fragment>
                                            {hasPickupsfromFD || hasDeliveries ? (
                                                <Fragment>
                                                    {!hasPickupsfromFD && (
                                                        <p className="no-actions">
                                                            There were <span>no pickups</span> on this day.
                                                        </p>
                                                    )}
                                                    {!hasDeliveries && (
                                                        <p className="no-actions">
                                                            There were <span>no deliveries</span> on this day.
                                                        </p>
                                                    )}
                                                    {combinedItems &&
                                                        combinedItems.length > 0 &&
                                                        combinedItems.map((item, idx) => (
                                                            <Fragment key={idx}>
                                                                {item.Type &&
                                                                    item.Type === 'readCMCremationDispatchDates' && (
                                                                        <DeliveryRunsheet
                                                                            key={'delivery' + item.ID}
                                                                            delivery={item}
                                                                            countA={1 + idx}
                                                                        />
                                                                    )}
                                                                {item.Type && (item.Type === 'readCMEnquiries' || item.Type === 'readCremationOrders') && (
                                                                    <PickupRunsheet
                                                                        key={'pickup' + item.ID}
                                                                        pickup={item}
                                                                        countA={1 + idx}
                                                                    />
                                                                )}
                                                            </Fragment>
                                                        ))}
                                                </Fragment>
                                            ) : (
                                                <p className="no-actions">
                                                    There were <span>no pickups or deliveries</span> on this day.
                                                </p>
                                            )}
                                        </Fragment>
                                    </Grid>
                                </Grid>
                            </Paper>
                        );
                    })}
            </Fragment>
        );
    }

    renderPageContent() {
        const { dateFrom, dateTo } = this.state;
        const variables1 = {
            fromPickupDate: dateFrom,
            toPickupDate: dateTo
        };

        const variables2 = {
            filterBy: [{ field: 'DispatchMethod', value: 'Delivered to' }],
            fromDate: dateFrom,
            toDate: dateTo,
            excludePickups: true
        };

        const variables3 = {
            fromPickupDate: dateFrom,
            toPickupDate: dateTo
        };

        return (
            <Fragment>
                <Query
                    query={enquiryQuery}
                    fetchPolicy="cache-and-network"
                    variables={variables1}
                    ref={this.runsheetQueryRef}
                >
                    {response1 => {
                        if (response1.loading && !response1.data) {
                            return (
                                <Fragment>
                                    <div>Loading data, please wait a moment...</div>
                                    <LinearProgressIndicator />
                                </Fragment>
                            );
                        }

                        return (
                            <Query
                                query={dispatchDatesQuery}
                                fetchPolicy="cache-and-network"
                                variables={variables2}
                                ref={this.runsheetQueryRef2}
                            >
                                {response2 => {
                                    if (response2.loading && !response2.data) {
                                        return (
                                            <Fragment>
                                                <div>Loading data, please wait a moment...</div>
                                                <LinearProgressIndicator />
                                            </Fragment>
                                        );
                                    }

                                    return (
                                        <Query
                                            query={cremationOrderQuery}
                                            fetchPolicy="cache-and-network"
                                            variables={variables3}
                                            ref={this.runsheetQueryRef3}
                                        >
                                            {response3 => {
                                                if (response3.loading && !response3.data) {
                                                    return (
                                                        <Fragment>
                                                            <div>Loading data, please wait a moment...</div>
                                                            <LinearProgressIndicator />
                                                        </Fragment>
                                                    );
                                                }

                                                const data = { ...response1.data, ...response2.data, ...response3.data };
                                                if (
                                                    !data.readCMEnquiries?.edges ||
                                                    !data.readCMCremationDispatchDates?.edges || 
                                                    !data.readCremationOrders?.edges
                                                ) {
                                                    return (
                                                        <Fragment>
                                                            <div>Loading data, please wait a moment...</div>
                                                            <LinearProgressIndicator />
                                                        </Fragment>
                                                    );
                                                }
                                                this.storePolling = {
                                                    start: [response1.startPolling, response2.startPolling, response3.startPolling],
                                                    stop: [response1.stopPolling, response2.stopPolling, response3.stopPolling]                                               
                                                };
                                                return this.renderDays(data, response3.networkStatus);
                                            }}
                                        </Query>
                                    );
                                }}
                            </Query>
                        );
                    }}
                </Query>
            </Fragment>
        );
    }

    render() {
        return (
            <Fragment>
                {this.renderHeader()}
                <Grid container>
                    <Grid item>
                        <div className="runsheet-paper" ref={e => (this.formRef = e)}>
                            {this.renderPageContent()}
                        </div>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }
}

const cremationOrderQuery = gql`
    ${Deceased}
    ${Member}
    ${CremationManagerAddressBook}
    ${Pickup}

    fragment CremationOrderFrag on CremationOrder {
        ID
        Created
        LegacyKey
        EnquirerWasBusiness
        CremationDate
        CremationTime
        SameDayCremation
        NextDayCremation
        RequestsCertificateOfContents
        PickupMethod
        Deceased {
            ...Deceased
        }
        Business {
            ...CremationManagerAddressBook
        }
        Pickup {
            ...Pickup
        }
    }

    query runsheetCremationOrders($fromPickupDate: String, $toPickupDate: String) {
        readCremationOrders(fromPickupDate: $fromPickupDate, toPickupDate: $toPickupDate) {
            edges {
                node {
                    ...CremationOrderFrag
                }
            }
        }
    }
`;

const enquiryQuery = gql`
    ${Deceased}
    ${Member}
    ${CremationManagerAddressBook}
    ${Pickup}
    fragment EnquiryFrag on CMEnquiry {
        ID
        Created
        LegacyKey
        EnquiryByBusiness
        EnquiryType
        ClientSameAsEnquirer
        Notes
        CremationDate
        CremationTime
        SameDayCremation
        NextDayCremation
        RequestsCertificateOfContents
        PickupMethod
        CremationOrder {
            ID
            LegacyKey
            CremationCancelled
        }
        Deceased {
            ...Deceased
        }
        Business {
            ...CremationManagerAddressBook
        }
        Pickup {
            ...Pickup
        }
    }

    query runsheetEnquiries($fromPickupDate: String, $toPickupDate: String) {
        readCMEnquiries(fromPickupDate: $fromPickupDate, toPickupDate: $toPickupDate) {
            edges {
                node {
                    ...EnquiryFrag
                }
            }
        }
    }
`;

const dispatchDatesQuery = gql`
    ${Address}
    ${CremationManagerAddressBook}
    ${Member}
    ${Client}

    fragment DispatchDatesFrag on CMCremationDispatchDate {
        ID
        Date
        Time
        ContainmentStyle
        CremationOrderID
        CremationOrder{
            ID
            LegacyKey
            EnquirerWasBusiness
            Client {
                ...Client
            }
            Business {
                ...CremationManagerAddressBook
            }
            Deceased {
                ID
                Surname
                MiddleName
                FirstName
            }
        }
        Enquiry{
            ID
            LegacyKey
            ClientSameAsEnquirer
            Business {
                ...CremationManagerAddressBook
            }
            Client {
                ...Client
            }
            Deceased {
                ID
                Surname
                MiddleName
                FirstName
            }
        }
        Ashes
        DispatchMethod
        AshesCollectedBy
        Comment
        DispatchComplete
        FuneralDirector
        DestinationAddress {
            ...Address
        }
        AssignedStaff {
            ...Member
        }
    }

    query runsheetDispatchDates($fromDate: String, $toDate: String, $filterBy: [Filters]) {
        readCMCremationDispatchDates(fromDate: $fromDate, toDate: $toDate, excludePickups: true, filterBy: $filterBy) {
            edges {
                node {
                    ...DispatchDatesFrag
                }
            }
        }
    }
`;

export default withErrorBoundary(compose(withRouter, withStyles({}))(Delivery), { fallback: ErrorFallback });
